import i18next from 'i18next';
import { find, identity } from 'lodash';

import {
  AppConfigArea,
  AppConfigKey,
  AppConfigValueType,
  ShopIntegrationType,
} from 'enums';
import { Bank } from 'types';

import { p2pProviderUtils } from './p2p-provider.utils';
import { payoutRequisitesAutomationUtils } from './payout-requisites-automation.utils';

const getShopIntegrationTypeLabel = (type: ShopIntegrationType) =>
  i18next.t(`shop_integration_config.types.${type}`, { defaultValue: type });

const getEntityTypeLabel = (
  area?: AppConfigArea,
  banks?: Bank[],
): ((type: any) => string) => {
  switch (area) {
    case AppConfigArea.PayinP2PProvider:
    case AppConfigArea.PayoutP2PProvider:
      return p2pProviderUtils.getTypeLabel;
    case AppConfigArea.PayoutRequisitesAutomation:
      return payoutRequisitesAutomationUtils.getTypeLabel;
    case AppConfigArea.PayinRequisites:
      return (id: string) => find(banks, (bank) => bank.id === id)?.name || id;
    case AppConfigArea.ShopsCommon:
      return getShopIntegrationTypeLabel;
    default:
      return identity;
  }
};

const getKeyLabel = (key: AppConfigKey) =>
  i18next.t(`app_config_key.${key}`, { defaultValue: key });

const getValueField = (valueType: AppConfigValueType) => {
  if (valueType === AppConfigValueType.JsonObject) {
    return 'jsonObjectValue';
  } else if (valueType === AppConfigValueType.JsonArray) {
    return 'jsonArrayValue';
  }
  return '';
};

export const appConfigUtils = {
  getEntityTypeLabel,
  getKeyLabel,
  getShopIntegrationTypeLabel,
  getValueField,
};
